import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  TAuditObjectsHistoryParams,
  TAuditObjectsHistoryRes,
  TAuditObjectsIdParams,
  TAuditObjectsIdRes,
  TAuditObjectsParams,
  TAuditObjectsRes,
} from '../types/audit.types';

export const useGetAuditObjectsQuery = (
  params?: TAuditObjectsParams,
  options?: any,
): UseQueryResult<TAuditObjectsRes> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.AuditQueryKeys].getAuditObjects(params),
    ...options,
  });

export const useGetAuditObjectsHistoryQuery = (
  params?: TAuditObjectsHistoryParams,
  options?: any,
): UseQueryResult<TAuditObjectsHistoryRes> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.AuditQueryKeys].getAuditObjectsHistory(params),
    ...options,
  });

export const useGetAuditObjectsIdQuery = (
  params?: TAuditObjectsIdParams,
  options?: any,
): UseQueryResult<TAuditObjectsIdRes> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.AuditQueryKeys].getAuditObjectsId(params),
    ...options,
  });
